<template>
  <div class="container">
    <div class="modal bg-color-B" tabindex="-1" id="chargeWallet">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0"  data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row">
              <div class="col-auto mouse-hand" @click="closePopupCharge" >
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>
            <h6 class="modal-title text-center almarai-bold py-2">{{$t('balanceInsufficient')}}</h6>
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="small-Font">{{$t('chargeWallet')}}</div>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 col-md-8">
                <router-link to="/wallet">
                  <div class="btn-green fonttext-14">{{$t('btnChargeWallet')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'chargeWallet',

  methods: {
    closePopupCharge(){
      document.getElementById('chargeWallet').style.display = 'none';
    },
  }
}
</script>